import { render } from "./InputTextarea.vue?vue&type=template&id=29b1be27&scoped=true&ts=true"
import script from "./InputTextarea.vue?vue&type=script&lang=ts"
export * from "./InputTextarea.vue?vue&type=script&lang=ts"

import "./InputTextarea.vue?vue&type=style&index=0&id=29b1be27&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\vue-gpt-sample\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b1be27"]])

export default __exports__